export default __webpack_public_path__ + "static/media/phone_red.155af161.svg";